<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn
                    class="mr-1"
                    small
                    color="primary"
                    dark v-on="{...tooltip, ...dialog}"
                    v-on:click="()=>dialog=!dialog"
                >
                    <v-icon>mdi-circle-edit-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('referenceBooks.devices.EditProducts')}}</span>
        </v-tooltip>
        <DragForm
            v-model="dialog"
            @close="$emit('close')"
        >
            <v-card width="800">
                <v-card-title>
                    <span class="headline">{{$t('referenceBooks.devices.EditProducts')}}</span>
                </v-card-title>
                <v-card-text style="overflow-y: auto;  max-height: 400px">
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.banks.Name')}} : {{device.bankName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.branches.Name')}} : {{device.branchName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.devices.Name')}} : {{device.deviceName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.devices.DeviceTypeName')}} : {{device.deviceTypeName}}
                            </v-col>

                        </v-row>
                    </v-container>
                    <ManageDeviceProductsList
                            :device="device"
                            @changed="(i, items) => selectedProducts[i-1] = items"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('Close')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="save">{{$t('Save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import ManageDeviceProductsList from '@/components/ManageDeviceProductsList';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  name: 'AttachProductsToDeviceDialog',
  components: {DragForm, ManageDeviceProductsList},
  props: {
    device: {
      type: Object,
      required: true
    },
    deviceId: {
      type: Number,
    },
    showDialogDefault: Boolean
  },
  data() {
    return {
      actionPerformed: false,
      success: false,
      error: false,
      products: [],
      dialog: false,
      selectedProducts: []
    };
  },
  watch: {
    dialog(val) {
      if (val) this.getProducts();
    }
  },
  methods: {
    clearData(){
      this.actionPerformed = false,
      this.success = false,
      this.error = false;
      this.products = [],
      this.selectedProducts = [];
    },
    close() {
      this.$emit('close');
    },
    async save() {
      await this.$axios
        .products.attachProductsToDevice(
          this.device.deviceId,
          this.selectedProducts
            .map((array, index) => ({hopper: index + 1, productsId: array.map(p => p.productId)}))
            .filter(x => x.productsId.length)
        )
        .then(response => {
          notifySuccess('', this.$t('Messages.ProductsWereAttachedToDevice', [this.device.deviceName]));
          this.$emit('attach', response.status, this.device.deviceId);
          this.$emit('close');
        })
        .catch(error => {
          notifyError('', this.$t('Error'));
          console.error(error);
          this.$emit('error', error);
        });
    },
    async getProducts() {
      await this.$axios.products.getAvailableForDevice(this.device.deviceId)
        .then(response => response.data)
        .then(json => this.products = json)
        .catch(error => console.error(error));

    },

  },
  async mounted() {
    this.dialog = this.showDialogDefault;
    await this.getProducts();
  }

};
</script>